
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30 27h-2v-9.063a.1.1 0 00-.012-.05l-1.875-13.15A2 2 0 0024.137 3h-2.274a2 2 0 00-1.976 1.713l-1.45 10.125L13.6 11.2a1 1 0 00-1.6.8v4l-6.4-4.8A1 1 0 004 12v15H2a1 1 0 000 2h28a1 1 0 000-2zm-17.5-3H9a1 1 0 010-2h3.5a1 1 0 010 2zM23 24h-3.5a1 1 0 010-2H23a1 1 0 010 2zm-1.663-7l-1.075-.8 1.6-11.2h2.276l1.712 12h-4.513z","fill":"currentColor"}})])
          )
        }
      }
    